import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0d06ecaf&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0d06ecaf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d06ecaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d06ecaf')) {
      api.createRecord('0d06ecaf', component.options)
    } else {
      api.reload('0d06ecaf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0d06ecaf&scoped=true", function () {
      api.rerender('0d06ecaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/examine/index.vue"
export default component.exports